const legacyColors = {
  blue_light: '#99c8e4',
  green: '#25b774',
  yellow: '#ffda58',
  red: '#ff6961',
  brown_light: '#a38f7e',
  orange: '#ffa43f',
  blue_dark: '#00588d',
  purple_light: '#b2a1db',
  blue: '#0076bc',
  green_dark: '#0d7f46',
  brown: '#6b645f',
  purple: '#886bc1',
  gray: '#ccc',
  pastel_34520: '#d5dcfc',
  pastel_34519: '#d9cbf9',
  pastel_34518: '#c8fdcc',
  pastel_34517: '#d3b9c5',
  pastel_34516: '#e7d9d3',
  pastel_34521: '#fee7ea',
  pastel_34515: '#cafee9',
  pastel_34506: '#f9edd7'
}

// Source - https://colorcet.holoviz.org/user_guide/Categorical.html
const newColors = {
  blue_bright: '#0094CB',
  red_bright: '#F03B2B',
  gold_bright: '#CE9239',
  green_vivid: '#56B142',
  purple_dark: '#694888',
  red_dark: '#B0121F',
  blue_deep: '#005886',
  pink_muted: '#B25391',
  brown_dark: '#653A34',
  purple_very_dark: '#3a0182',
  green_dark: '#004200',
  mint: '#0FFFA8',
  burgundy: '#5D003F',
  lavender_light: '#C6BCFF',
  magenta_deep: '#B80080',
  pink_soft: '#FFB6B3',
  red_deep_dark: '#7C0100',
  blue_violet: '#6026FF',
  yellow_light: '#FFFF9A',
  green_grayish: '#AEC8AA',
  teal_dark: '#00857C',
  brown_very_dark: '#543A00',
  cyan_light: '#93FBFF',
  green_bright: '#00BF00',
  purple: '#7C00A0',
  lime: '#90FF00',
  teal: '#01BD89',
  blue_darker: '#00447B',
  beige: '#C8826E',
  pink_bright: '#FF1F82',
  magenta: '#DD00FF',
  green_deep: '#057400',
  lavender: '#878EFF',
  pink_pale: '#FFB5F4',
  green_dark_muted: '#526236',
  purple_light: '#CD85FF',
  gray_pink: '#BDB3BD',
  pink_grayish: '#A56089',
  blue_sky: '#95D3FF',
  blue_deep_bright: '#0100F7',
  orange_bright: '#FF8001',
  red_purple: '#8A2844',
  khaki: '#ACA06D'
}

const colorsV2 = {
  // Grays
  gray_50: '#f9fafb',
  gray_100: '#f3f4f6',
  gray_200: '#e5e7eb',
  gray_300: '#d1d5db',
  gray_400: '#9ca3af',
  gray_500: '#6b7280',
  gray_600: '#4b5563',
  gray_700: '#374151',
  gray_800: '#1f2937',
  gray_900: '#111827',

  // Reds
  red_50: '#fdf2f2',
  red_100: '#ffe9e9',
  red_200: '#fad5d5',
  red_300: '#f4b0b0',
  red_400: '#f67d7c',
  red_500: '#eb4d4d',
  red_600: '#d51919',
  red_700: '#be1414',
  red_800: '#8f1010',
  red_900: '#691515',

  // Yellows
  yellow_50: '#fcfce9',
  yellow_100: '#fbf4b0',
  yellow_200: '#fae768',
  yellow_300: '#f8c813',
  yellow_400: '#e19e06',
  yellow_500: '#d38204',
  yellow_600: '#c06501',
  yellow_700: '#b65906',
  yellow_800: '#8a3e08',
  yellow_900: '#6a2800',

  // Greens
  green_50: '#f3faf7',
  green_100: '#def7ec',
  green_200: '#bcf0da',
  green_300: '#84e1bc',
  green_400: '#31c48d',
  green_500: '#0e9f6e',
  green_600: '#057a55',
  green_700: '#046c4e',
  green_800: '#03543f',
  green_900: '#014737',

  // Primary (Blues)
  primary_50: '#e3f5ff',
  primary_100: '#c8e9fc',
  primary_200: '#89cff8',
  primary_300: '#59b9f2',
  primary_400: '#2aa2ea',
  primary_500: '#1184c9',
  primary_600: '#0076bc',
  primary_700: '#085887',
  primary_800: '#14425e',
  primary_900: '#002338',

  // Purples
  purple_50: '#f6f5ff',
  purple_100: '#e8e6f9',
  purple_200: '#dcd7fe',
  purple_300: '#c2b7f5',
  purple_400: '#a48cf2',
  purple_500: '#8859f1',
  purple_600: '#7a36ee',
  purple_700: '#6423d1',
  purple_800: '#501cb0',
  purple_900: '#451891'
}

const colorSequenceV2 = [
  // 600 series (primary)
  colorsV2.primary_600, // blue
  colorsV2.red_600, // red
  colorsV2.green_600, // green
  colorsV2.yellow_300, // yellow
  colorsV2.purple_600, // purple
  colorsV2.gray_600, // gray

  // 300 series (lighter)
  colorsV2.primary_300, // blue
  colorsV2.red_300, // red
  colorsV2.green_300, // green
  colorsV2.yellow_600, // yellow
  colorsV2.purple_300, // purple
  colorsV2.gray_300, // gray

  // 700 series (darker)
  colorsV2.primary_700, // blue
  colorsV2.red_700, // red
  colorsV2.green_700, // green
  colorsV2.yellow_700, // yellow
  colorsV2.purple_700, // purple
  colorsV2.gray_700, // gray

  // 500 series (medium)
  colorsV2.primary_500, // blue
  colorsV2.red_500, // red
  colorsV2.green_500, // green
  colorsV2.yellow_500, // yellow
  colorsV2.purple_500, // purple
  colorsV2.gray_500, // gray

  // 400 series (medium-light)
  colorsV2.primary_400, // blue
  colorsV2.red_400, // red
  colorsV2.green_400, // green
  colorsV2.yellow_400, // yellow
  colorsV2.purple_400, // purple
  colorsV2.gray_400, // gray

  // 800 series (very dark)
  colorsV2.primary_800, // blue
  colorsV2.red_800, // red
  colorsV2.green_800, // green
  colorsV2.yellow_800, // yellow
  colorsV2.purple_800, // purple
  colorsV2.gray_800, // gray

  // 200 series (very light)
  colorsV2.primary_200, // blue
  colorsV2.red_200, // red
  colorsV2.green_200, // green
  colorsV2.yellow_200, // yellow
  colorsV2.purple_200, // purple
  colorsV2.gray_200, // gray

  // 900 series (darkest)
  colorsV2.primary_900, // blue
  colorsV2.red_900, // red
  colorsV2.green_900, // green
  colorsV2.yellow_900, // yellow
  colorsV2.purple_900, // purple
  colorsV2.gray_900, // gray

  // 100 series (lightest)
  colorsV2.primary_100, // blue
  colorsV2.red_100, // red
  colorsV2.green_100, // green
  colorsV2.yellow_100, // yellow
  colorsV2.purple_100, // purple
  colorsV2.gray_100 // gray
]

const colors = () => {
  return colorSequenceV2
}

// http://stackoverflow.com/a/25709983
// We should generate colours based on input (e.g. DealLossReason name)
const letters = '0123456789ABCDEF'.split('')

export const getRandomColor = () => {
  let color = '#'

  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }

  return color
}

export const getColor = (index) => {
  const availableColors = Object.values(colors())
  if (index < availableColors.length) {
    return availableColors[index]
  } else {
    return getRandomColor()
  }
}

export const getColors = (num) => {
  const colors = []

  for (let i = 0; i < num; i++) {
    colors.push(getColor(i))
  }

  return colors
}

export const getColorByName = (name) => {
  return colors()[name.toLowerCase()]
}

export const getDealStatusColor = (dealStatusId, dealStatuses) => {
  const dealStatus = dealStatuses.find(ds => ds.id === dealStatusId)
  return dealStatus ? `#${dealStatus.hex_color}` : getColor(0)
}
